// constucts the event name based on the name, vid and control id
function _constructEventName(eventName, targetViewId, controlId) {
  if (!targetViewId || targetViewId == "null") {
    targetViewId = "";
  }
  if (!controlId) {
    controlId = "";
  }
  return eventName + "_" + targetViewId + "_" + controlId;
}
/**
 Radio.js - Chainable, Dependency Free Publish/on for Javascript
 http://radio.uxder.com
 Author: Scott Murphy 2011
 twitter: @hellocreation, github: uxder

 Permission is hereby granted, free of charge, to any person
 obtaining a copy of this software and associated documentation
 files (the "Software"), to deal in the Software without
 restriction, including without limitation the rights to use,
 copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the
 Software is furnished to do so, subject to the following
 conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 OTHER DEALINGS IN THE SOFTWARE.
 */
(function(name, global, definition) {
  global[name] = definition(name, global);
})("SystemEvents", this, function(name, global) {
  "use strict";
  /**
   * Main Wrapper for radio.$ and create a function radio to accept the channelName
   * @param {String} channelName topic of event
   */
  function SystemEvents(channelName, targetViewId, controlId) {
    var name = _constructEventName(channelName, targetViewId, controlId);
    arguments.length ? SystemEvents.$.channel(name) : SystemEvents.$.reset();
    return SystemEvents.$;
  }
  SystemEvents.$ = {
    version: "0.2",
    channelName: "",
    channels: [],
    /**
     * Reset global state, by removing all channels
     * @example
     *    SystemEvents()
     */
    reset: function() {
      SystemEvents.$.channelName = "";
      SystemEvents.$.channels = [];
    },
    /**
     * trigger (publish)
     * Iterate through all listeners (callbacks) in current channel and pass arguments to onrs
     * @param arguments data to be sent to listeners
     * @example
     *    //basic usage
     *    SystemEvents('channel1').trigger('my message');
     *    //send an unlimited number of parameters
     *    SystemEvents('channel2').trigger(param1, param2, param3 ... );
     */
    trigger: function() {
      log("Triggering the '" + this.channelName + "' event");
      var result = true;
      var i,
        c = this.channels[this.channelName],
        l = c.length,
        onr,
        callback,
        context;
      //iterate through current channel and run each onr
      for (i = 0; i < l; i++) {
        onr = c[i];
        //if onr was an array, set the callback and context.
        if (typeof onr === "object" && onr.length) {
          callback = onr[0];
          //if user set the context, set it to the context otherwise, it is a globally scoped function
          context = onr[1] || global;
        }
        var r = callback.apply(context, arguments);
        if (r === false) {
          result = false;
        }
      }
      this.result = result;
      return this;
    },
    /**
     * Create the channel if it doesn't exist and set the current channel/event name
     * @param {String} name the name of the channel
     * @example
     *    SystemEvents('channel1');
     */
    channel: function(name) {
      var c = this.channels;
      //create a new channel if it doesn't exists
      if (!c[name]) c[name] = [];
      this.channelName = name;
      return this;
    },
    /**
     * Add onr to channel
     * Take the arguments and add it to the this.channels array.
     * @param {Function|Array} arguments list of callbacks or arrays[callback, context] separated by commas
     * @example
     *      //basic usage
     *      var callback = function() {};
     *      SystemEvents('channel1').on(callback);
     *
     *      //on an endless amount of callbacks
     *      SystemEvents('channel1').on(callback, callback2, callback3 ...);
     *
     *      //adding callbacks with context
     *      SystemEvents('channel1').on([callback, context],[callback1, context], callback3);
     *
     *      //on by chaining
     *      SystemEvents('channel1').on(callback).SystemEvents('channel2').on(callback).on(callback2);
     */
    on: function() {
      var a = arguments,
        c = this.channels[this.channelName],
        i,
        l = a.length,
        p,
        ai = [];
      //run through each arguments and on it to the channel
      for (i = 0; i < l; i++) {
        ai = a[i];
        //if the user sent just a function, wrap the fucntion in an array [function]
        p = typeof ai === "function" ? [ai] : ai;
        if (typeof p === "object" && p.length) c.push(p);
      }
      return this;
    },
    /**
     * Remove onr from channel
     * Take arguments with functions and off it if there is a match against existing onrs.
     * @param {Function} arguments callbacks separated by commas
     * @example
     *      //basic usage
     *      SystemEvents('channel1').off(callback);
     *      //you can off as many callbacks as you want
     *      SystemEvents('channel1').off(callback, callback2, callback3 ...);
     *       //removing callbacks with context is the same
     *      SystemEvents('channel1').on([callback, context]).off(callback);
     */
    off: function() {
      var a = arguments,
        i,
        j,
        c = this.channels[this.channelName],
        l = a.length,
        cl = c.length,
        offset = 0,
        jo;
      //loop through each argument
      for (i = 0; i < l; i++) {
        //need to reset vars that change as the channel array items are removed
        offset = 0;
        cl = c.length;
        //loop through the channel
        for (j = 0; j < cl; j++) {
          jo = j - offset;
          //if there is a match with the argument and the channel function, off it from the channel array
          if (c[jo][0] === a[i]) {
            //off matched item from the channel array
            c.splice(jo, 1);
            offset++;
          }
        }
      }
      return this;
    }
  };
  return SystemEvents;
});
